module.exports = __webpack_public_path__ + "static/media/rightArrow.6d6a417d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rightArrow.svg
// module id = 201
// module chunks = 0